import { useEffect, useState } from 'react';
import className from 'classnames/bind';

import styles from './index.module.scss';
const cx = className.bind(styles);

interface radioProps {
  key: string;
  value: string;
}

interface radioButtonProps {
  title: string;
  defaultValue?: string;
  data: radioProps[];
  onClick?: (key: string) => {};
}

const RadioButton = ({
  title = '',
  defaultValue = '',
  data = [],
  onClick,
}: radioButtonProps) => {
  const [checked, setChecked] = useState('');

  const onChangeHandler = (event: any) => {
    setChecked(event.target.value);
  };

  useEffect(() => {
    setChecked(defaultValue);
  }, [defaultValue]);

  return (
    <div className={styles.container}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.radioButton}>
        {data.map((x) => {
          const carTypeClass = cx({
            active: x.key === checked,
          });

          return (
            <label key={x.key} htmlFor={x.key} className={carTypeClass}>
              <input
                id={x.key}
                value={x.key}
                checked={x.key === checked}
                name="vehicleType"
                type="radio"
                onChange={onChangeHandler}
                onClick={() => {
                  if (onClick) {
                    onClick(x.key);
                  }
                }}
              />
              <span>{x.value}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default RadioButton;
